import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
    body {
        margin: 0;
        padding: 0;
        font-family: ${(props) => props.theme.bodyFont || 'sans-serif'};
    }

    h1, h2, h3, h4, h5, h6 {
        font-family: ${(props) => props.theme.titleFont || props.theme.bodyFont || 'sans-serif'};
        user-select: none;
        font-weight: normal;
    }

    button, input, textarea, select {
        font-family: ${(props) => props.theme.bodyFont || 'sans-serif'};
    }
`;
